import request from '../utils/request';
import { buildApiPayload } from '../utils/api';
import baseApi from './baseApi';

export function getConveyorEvents(params, signal) {
  return request({
    url: '/conveyorTimerCycleHistory',
    method: 'get',
    data: buildApiPayload({ payload: params, dateEndKeys: ['endTime'] }),
    signal,
  });
}

export function getConveyorTotal(params, signal) {
  return request({
    url: '/conveyorTimerCycleHistory/total',
    method: 'get',
    data: buildApiPayload({ payload: params, dateEndKeys: ['endTime'] }),
    signal,
  });
}

export function getExelExport(params) {
  return request({
    url: '/conveyorTimerCycleHistory/xls',
    method: 'get',
    data: buildApiPayload({ payload: params, dateEndKeys: ['endTime'] }),
    responseType: 'arraybuffer',
  });
}

export function deleteConveyor(uuid) {
  return request({
    url: `/conveyorTimerCycleHistory/${uuid}`,
    method: 'delete',
  });
}

const conveyorApi = baseApi.injectEndpoints({
  endpoints: builder => ({
    bulkDeleteConveyorTCHs: builder.mutation({
      query: ({ uuids }) => ({
        url: '/conveyorTimerCycleHistory',
        method: 'DELETE',
        data: {
          uuids,
        },
      }),
    }),
  }),
});

export const {
  useBulkDeleteConveyorTCHsMutation: useBulkDeleteConveyorTCHs,
} = conveyorApi;

export default conveyorApi;
